import './styles/cta.css'
import SubTitle from './core/SubTitle'
import Text from './core/Text'
import BlueBtn from './UI/BlueBtn'
import ctaImg1 from '../assets/images/img1.png'
import ctaImg2 from '../assets/images/img2.png'

export default function Cta() {
  return (
    <div className='cta'>
        <div className='cta__item first'>
            <div className='cta__item-info first'>
                <div className='cta__item-title first'>
                <SubTitle text='First CTA'/>
                </div>
                <div className="cta__item-text first">
                <Text
                customClass='cta__item-text-first1'
                color='#404046'
                text={`Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
                sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                 Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi 
                ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit`}
                />
                <Text
                color='#404046'
                text={` esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                 sunt in culpa qui officia deserunt mollit anim id est laborum. esse cillum dolore eu fugiat
                  nulla pariatur. Excepteur sint occaecat cupidatat.
                `}
                />
                </div>
                <div className='cta__item-btn first'>
                <BlueBtn text={'Build your resume'} width={'158'}/>
                </div>
            </div>
            <div className='cta__item-img first desktop-img'>
                <img src={ctaImg1} alt={'cta-img'}/>
            </div>
            <div className='cta__item-img first mobile-img'>

            </div>
        </div>

        <div id='features' className='cta__item second reverse'>
            <div className='cta__item-info second'>
                <div className='cta__item-title second'>
                    <SubTitle text='Second CTA'/>
                </div>
                <div className="cta__item-text second">
                <Text
                color='#404046'
                text={`Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
                sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                 Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi 
                ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit`}
                />
                <Text
                customClass='cta-item-text-tranform'
                color='#404046'
                text={`
                esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                 sunt in culpa qui officia deserunt mollit anim id est laborum. esse cillum dolore eu fugiat
                  nulla pariatur. Excepteur sint occaecat cupidatat.
                `}
                />
                </div>
                <BlueBtn text={'Resume templates'} width={'165'}/>
            </div>
            <div className='cta__item-img second desktop-img'>
                <img src={ctaImg2} alt={'cta-img'}/>
            </div>
            <div className='cta__item-img second mobile-img'>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
  )
}
